import React from 'react';
import PropTypes from 'prop-types';
import { CustomBadgeStyled } from './CustomBadgeStyled';
/*
 * textColor:
 */
const CustomBadge = ({ text, customClass, upperCase, textColor, backgroundColor, marginBottom }) => {
  return (
    <CustomBadgeStyled
      className={customClass}
      upperCase={upperCase}
      textColor={textColor}
      backgroundColor={backgroundColor}
      marginBottom={marginBottom}
    >
      <div className="wrapper">{text}</div>
    </CustomBadgeStyled>
  );
};
/*
 * it will provide types for the props.
 */
CustomBadge.propTypes = {
  text: PropTypes.string,
  customClass: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  upperCase: PropTypes.bool,
  marginBottom: PropTypes.string,
};
CustomBadge.defaultProps = { text: '', customClass: '', upperCase: false };

export default CustomBadge;
